// extracted by mini-css-extract-plugin
module.exports = {"reportingPieChart":"firmenichChart_reportingPieChart__3Y9XJ","reset":"firmenichChart_reset__bLTRE","chartWrapper":"firmenichChart_chartWrapper__26ZpF"};